import React, { useState, useEffect } from 'react'
import PopupModal from '../../../../components/popup-bottom-modal'
import { CHARGE_CDN } from '../../../../utils/constants'
import { getCloseReasonEnum, closeShare, applyUseRefuseReasonEnum, useShareApplyApproval } from '../../api'
import './index.less'
import TagList from '../tag-list'
import Toast from '@xpeng/rc-toast'
import { Button, Space } from '@xp-design/mobile'
import { trackGdp } from '../../../../utils/gio-report'
import { UserTypeEnum } from '../../../../api/pile'
interface SharingCloseModalPropsRule {
    visible: boolean
    setVisible: (status: boolean) => void
    approvalId?: string
    refreshList: () => void
    userInfo: any
}
const SharingRejectModal = (props: SharingCloseModalPropsRule) => {
    const { visible, setVisible, approvalId, refreshList, userInfo } = props
    const [rejectReasonList, setRejectReasonList] = useState<any[]>([])
    const [selectedReason, setSelectedReason] = useState<any>({})
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        getData()
    }, [])
    const getData = async () => {
        const { data } = await applyUseRefuseReasonEnum()
        if (data?.length) {
            setRejectReasonList(data)
        }
    }
    useEffect(() => {
        if (visible) {
            trackGdp('P20075', 'B016', {
                userId: userInfo?.uid,
                userType: UserTypeEnum[userInfo?.type],
                user_type: UserTypeEnum[userInfo?.type],
            })
        }
    }, [
        visible
    ])
    const close = async () => {
        // 上报埋点
        trackGdp('P20075', 'B017', {
            userId: userInfo?.uid,
            userType: UserTypeEnum[userInfo?.type]
        })

        if (!selectedReason.code) {
            Toast.show('请选择拒绝原因', {
                containerStyle: {
                    zIndex: 9999
                }
            })
            return
        }

        if (approvalId) {
            setLoading(true)
            try {
                let res = await useShareApplyApproval({
                    applyReqId: approvalId,
                    approvalResult: 3,
                    refuseReasonType: selectedReason.code
                })
                await new Promise(resolve => setTimeout(resolve, 3000)) // 延迟3000ms，确保提示能正确显示
                if (res?.code === 200) {
                    Toast.show('提交成功')
                    refreshList()
                    setVisible(false)
                } else {
                    Toast.show(res?.msg, {
                        containerStyle: {
                            zIndex: 9999
                        }
                    })
                }
            } catch (err) {
                await new Promise(resolve => setTimeout(resolve, 3000)) // 延迟3000ms，确保提示能正确显示
                Toast.show('提交失败', {
                    containerStyle: {
                        zIndex: 9999
                    }
                })
            } finally {
                setLoading(false)
            }
        } else {
            Toast.show('参数缺失', {
                containerStyle: {
                    zIndex: 9999
                }
            })
            // 确保没有遗留 loading 状态
            setLoading(false)
        }
    }
    return (
        visible
            ?
            <PopupModal
                visible={visible}
                title='选择拒绝原因'
                onClose={() => { if (loading) return; setVisible(false) }}
            >
                <div className='reject-container'>
                    <div
                        className='tag-list-container'
                        onClick={e => {
                            console.log('TagList container clicked, loading:', loading,)
                            if (loading) {
                                e.preventDefault()
                                e.stopPropagation()
                            }
                        }}
                    >
                        <TagList
                            list={rejectReasonList}
                            onChange={data => {
                                console.log('TagList onChange, selected:', data)
                                if (!loading) setSelectedReason(data)
                            }}
                        />
                    </div>
                    <div className='btn-container'>
                        <Button
                            className="cancel-btn"
                            loading={loading}
                            disabled={!selectedReason.code || loading}
                            onClick={close}
                        >
                            确认
                        </Button>
                    </div>
                </div>
            </PopupModal>
            : null
    )
}

export default SharingRejectModal